import { TextField, InputAdornment, IconButton } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import { Search, Close } from "@mui/icons-material";

interface EntitySearchInputProps {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	sx?: SxProps<Theme>;
}

export function EntitySearchInput({ value, onChange, placeholder = "Search...", sx }: EntitySearchInputProps) {
	return (
		<TextField
			size="small"
			value={value}
			onChange={(e) => onChange(e.target.value)}
			placeholder={placeholder}
			slotProps={{
				input: {
					startAdornment: (
						<InputAdornment position="start" sx={{ mr: 0.5 }}>
							<Search sx={{ fontSize: 16, color: "text.disabled" }} />
						</InputAdornment>
					),
					endAdornment: value ? (
						<InputAdornment position="end" sx={{ mr: -0.5 }}>
							<IconButton size="small" onClick={() => onChange("")} sx={{ p: 0.25 }}>
								<Close sx={{ fontSize: 14 }} />
							</IconButton>
						</InputAdornment>
					) : null,
				},
			}}
			sx={[
				{
					minWidth: 120,
					maxWidth: 200,
					flex: 1,
					"& .MuiOutlinedInput-root": {
						height: 28,
						fontSize: "0.75rem",
					},
					"& .MuiOutlinedInput-input": {
						py: 0.25,
						px: 0.5,
					},
				},
				...(Array.isArray(sx) ? sx : sx ? [sx] : []),
			]}
		/>
	);
}
